import { Injectable } from '@angular/core';
import {Observable, tap} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";

const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(private http: HttpClient) { }

  /**
   * encontrar vehiculo por placa
   */
  getAssignedServices(): Observable<any>{
    const body = JSON.stringify({});
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/serviceevent/getassignedservices`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  add(data: any): Observable<any>{
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/serviceevent/createserviceevent`,
        data,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * Funcion para cancelar un evento (status = 0)
   */
  cancelEvent(data:any): Observable<any>{
    const body = JSON.stringify({form:data});
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/serviceevent/cancelevent`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }
  /**
   * Función para mostrar o remover loading
   */
  controlLoader(show:boolean):void{
    // let elemet: any = document.getElementsByClassName("loader-screen")[0];
    // elemet.style.opacity = 0.8;
    // elemet.style.display = elemet.style.display === 'none' ? '' : 'none';
  }
}
